import { ArtJewelryType } from '/@/modules/asset/enums/ArtJewelryType';
import { AssetLocationMeta } from '/@/modules/asset/models/meta/AssetLocationMeta';

export class ArtJewelryAssetMeta extends AssetLocationMeta {
  /**
   * @var {string}
   */
  type;

  /**
   * @var {string}
   */
  precision;

  constructor(model = {}) {
    super(model);

    this.type = model.type;
    this.precision = model.precision;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return ArtJewelryType.getByKey(this.type).value;
  }

  /**
   *
   * @returns {boolean}
   */
  get isArtType() {
    return this.type === ArtJewelryType.ART.key;
  }

  /**
   *
   * @returns {boolean}
   */
  get isJewelryType() {
    return this.type === ArtJewelryType.JEWELRY.key;
  }

  /**
   *
   * @returns {boolean}
   */
  get isCollectionType() {
    return this.type === ArtJewelryType.COLLECTION.key;
  }
}
